import { render, staticRenderFns } from "./HeatingWaterControls.vue?vue&type=template&id=06f3a8d3&"
import script from "./HeatingWaterControls.vue?vue&type=script&lang=ts&"
export * from "./HeatingWaterControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports